module.exports = __webpack_public_path__ + "media/assets/faria_products/CAM-LS-52b093d8898491e0e11ca8c7b54dd7ed3292de7a77fd646cdf82db41afbda925.png";